import React from 'react';
import { Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../../Layout/Auth";
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
import LoginActivityPage from '../Pages/LoginActivityPage';

LoadingOverlay.propTypes = undefined;

function LoginActivityRoute() {
  const history = useHistory();
  return (
    <Switch>
      <Route
        exact
        path="/:lng/login-activities"
        render={() => (
          <Auth history={history} allowedRoles={['admin', 'staff', "revenue_manager", "revenue_staff"]}>
            {/* <Suspense fallback={<Loading />}> */}
            <LoginActivityPage history={history} />
            {/* </Suspense> */}
          </Auth>
        )}
      />
    </Switch>
  );
}

export default LoginActivityRoute;

function Loading() {
  return (
    <>
      <LoadingOverlay
        active={true}
        spinner={<FadeLoader />}
        text='Loading Login Activity...'
      />
    </>
  );
}
